import { render, staticRenderFns } from "./FourInAList.vue?vue&type=template&id=73a93214&scoped=true&"
import script from "./FourInAList.vue?vue&type=script&lang=js&"
export * from "./FourInAList.vue?vue&type=script&lang=js&"
import style0 from "./FourInAList.vue?vue&type=style&index=0&id=73a93214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a93214",
  null
  
)

export default component.exports